import { getFileHandleType, isImageFileHandleType } from "./blob";
import { saveAsJSON, type JSONExportData } from "./json";
import { saveAsPdf } from "./pdf";
import { resaveAsImageWithScene } from "./resave";

import type { MaybePromise } from "@excalidraw/common/utility-types";

export const saveSceneToFile = async ({
  data,
  filename,
  sourceFileHandle,
  fileHandle,
}: {
  data: MaybePromise<JSONExportData>;
  filename: string;
  sourceFileHandle: FileSystemFileHandle | null;
  fileHandle: FileSystemFileHandle | null;
}) => {
  const sourceFileHandleType = getFileHandleType(sourceFileHandle);

  if (isImageFileHandleType(sourceFileHandleType)) {
    return resaveAsImageWithScene(data, fileHandle, filename, sourceFileHandleType);
  }

  if (sourceFileHandleType === "pdf") {
    return saveAsPdf({
      data,
      filename,
      fileHandle,
    });
  }

  return saveAsJSON({
    data,
    filename,
    fileHandle,
  });
};
